import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField } from '@mui/material';
import { Box } from '@mui/system';
import axiosInstance from '../../../../config/axio.config';
import { useShowMessages } from '../../../../hooks/useMessages/useMessages';
import { levelsSupport } from '../../../../helpers';

const url = '/fr';

// O seguimento é a ponte com os sistemas e com o de-para do dataset da IA, que casa os
// pares Automação/Ponto. A API só aceita estes dois — por isso a lista é fechada aqui.
// O vazio é uma opção de verdade: grava NULL, como já existe na tabela.
const segments = [
  { value: '', label: 'Sem seguimento' },
  { value: 'Automação', label: 'Automação' },
  { value: 'Ponto', label: 'Ponto' },
];

const ReasonManager = (props) => {
  const { ShowMessage } = useShowMessages();
  const editing = !!props.values?.id;

  const handleChangeValues = (e) => {
    props.setValues((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleClose = () => {
    props.setOpen(false);
  };

  const handleClickSend = async () => {
    const description = (props.values?.description || '').trim();
    const type = (props.values?.type || '').trim();
    const level = Number(props.values?.level) || 1;

    if (!description) return ShowMessage('error', 'Informe a descrição do tipo de atendimento');

    try {
      if (editing) {
        await axiosInstance.put(url, { id: props.values.id, description, type, level });
        ShowMessage('success', 'Tipo de atendimento atualizado com sucesso!');
      } else {
        await axiosInstance.post(url, { description, type, level });
        ShowMessage('success', 'Tipo de atendimento cadastrado com sucesso!');
      }
      props.handleChanged();
      handleClose();
    } catch (error) {
      ShowMessage('error', error.response?.data?.message || 'Erro ao salvar o tipo de atendimento');
    }
  };

  return (
    <Dialog open={props.open} onClose={handleClose}>
      <DialogTitle>{editing ? 'Editar Tipo de Atendimento' : 'Novo Tipo de Atendimento'}</DialogTitle>
      <DialogContent>
        <Box sx={{ width: '100%', minWidth: '500px', mt: 1 }}>
          <TextField
            autoFocus
            name="description"
            value={props.values?.description || ''}
            label="Descrição"
            type="text"
            inputProps={{ maxLength: 50 }}
            onChange={handleChangeValues}
            fullWidth
            variant="filled"
          />
        </Box>
        <Box sx={{ width: '100%', minWidth: '500px', mt: 2 }}>
          <TextField
            select
            name="type"
            value={props.values?.type || ''}
            label="Seguimento"
            onChange={handleChangeValues}
            fullWidth
            variant="filled"
            // "Sem seguimento" tem valor vazio: sem isto o MUI não sobe o rótulo e os
            // dois textos ficam um por cima do outro.
            InputLabelProps={{ shrink: true }}
          >
            {segments.map((segment) => (
              <MenuItem key={segment.value} value={segment.value}>{segment.label}</MenuItem>
            ))}
          </TextField>
        </Box>
        <Box sx={{ width: '100%', minWidth: '500px', mt: 2 }}>
          <TextField
            select
            name="level"
            value={props.values?.level || 1}
            label="Nível de Suporte"
            onChange={handleChangeValues}
            fullWidth
            variant="filled"
          >
            {levelsSupport.map((option) => (
              <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
            ))}
          </TextField>
        </Box>
      </DialogContent>
      <DialogActions sx={{ paddingRight: 3 }}>
        <Button onClick={handleClose} variant="outlined" color="error">Cancelar</Button>
        <Button onClick={handleClickSend} variant="outlined" color="success">Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReasonManager;
